export const clientManagerTag = 'clientManager:';
